@if (tableTemplate) {
	<ng-template
		*mediaQuery="mediaQueryOverride ? mediaQueryMin[mediaQueryOverride] : mediaQueryMin.Desktop"
		[ngTemplateOutlet]="tableTemplate"
		[ngTemplateOutletContext]="{ $implicit: data, loading: loading }"
	>
	</ng-template>
}
@if (listItemTemplate) {
	<cjm-content
		*mediaQuery="mediaQueryOverride ? mediaQueryMax[mediaQueryOverride] : mediaQueryMax.Desktop"
		[loading]="loading"
		[error]="error"
		[errorText]="errorText"
	>
		<ol>
			@for (item of data; track item; let index = $index) {
				@if (item) {
					<li class="c-cjm-table-item u-margin-top">
						<ng-template
							[ngTemplateOutlet]="listItemTemplate"
							[ngTemplateOutletContext]="{ $implicit: item, $index: index }"
						>
						</ng-template>
					</li>
				}
			}
		</ol>
	</cjm-content>
}
